import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function positiveNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value !== null && value < 0) {
      return { negativeNumber: true }; // Validation error: "negativeNumber"
    }
    return null; // Valid input
  };
}
